import { createTextInputAdder } from './createTextInputAdder'

export const addComponentForNumberField = createTextInputAdder(
  'numberFieldTemplate',
)
